import { Routes } from '@angular/router';
import { loginPageRoutes } from "./features/pages/login-page/login-page.routes";
import { homePageRoutes } from "./features/pages/home-page/home-page.routes";

export const routes: Routes = [
  ...loginPageRoutes,
  ...homePageRoutes,
  {
    path: '**',
    redirectTo: '/'
  }
];
